(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CARD_SELECTOR = '.sg-review';

    function stripEditorRefs(node) {
      var els = [node].concat(Array.prototype.slice.call(node.querySelectorAll('*')));
      els.forEach(function (el) {
        if (el.id) el.removeAttribute('id');
        Array.prototype.slice.call(el.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) {
            el.removeAttribute(attr.name);
          }
        });
      });
    }

    function populate() {
      var track = document.querySelector('[data-sg-rc-track]');
      if (!track) return;

      track.innerHTML = '';

      var cards = document.querySelectorAll(CARD_SELECTOR);
      Array.prototype.forEach.call(cards, function (card) {
        // Never clone the carousel's own clones back into itself.
        if (card.closest('[data-sg-rc-track]')) return;

        var clone = card.cloneNode(true);
        stripEditorRefs(clone);
        clone.setAttribute('role', 'listitem');
        track.appendChild(clone);
      });
    }

    function step(track) {
      var card = track.querySelector('.sg-card');
      if (card) return card.getBoundingClientRect().width + 16;
      return track.clientWidth * 0.8;
    }

    function bindNav() {
      var scrollers = document.querySelectorAll('[data-sg-rc-scroller]');
      Array.prototype.forEach.call(scrollers, function (scroller) {
        if (scroller.dataset.sgRcBound) return;
        var track = scroller.querySelector('[data-sg-rc-track]');
        if (!track) return;
        scroller.dataset.sgRcBound = '1';

        var prev = scroller.querySelector('[data-sg-rc-prev]');
        var next = scroller.querySelector('[data-sg-rc-next]');
        if (prev) {
          prev.addEventListener('click', function () {
            track.scrollBy({ left: -step(track), behavior: 'smooth' });
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            track.scrollBy({ left: step(track), behavior: 'smooth' });
          });
        }
      });
    }

    function boot() {
      populate();
      bindNav();
    }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }

    // Theme Editor: re-clone whenever a section/block is added, edited, removed or reordered.
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', populate);
    document.addEventListener('shopify:section:reorder', populate);
    document.addEventListener('shopify:block:select', populate);
    document.addEventListener('shopify:block:deselect', populate);
  })();

  } catch(e) { console.error(e); }
})();
})();
